export enum DeviceType {
  UNKNOWN = 0,
  PHONE,
  TABLET,
  DESKTOP,
  TV,
}
